import * as tslib_1 from "tslib";
import * as moment from 'moment';
export function normalizeString(value) {
    var ret = value[0].toLocaleUpperCase();
    for (var i = 1; i < value.length; i++) {
        var char = value[i];
        if (char.toLocaleUpperCase() === char) {
            ret += " " + char;
        }
        else {
            ret += char;
        }
    }
    return ret;
}
export function timeToTime(time) {
    var _a = time.split(':'), hoursStr = _a[0], minutesAndTod = _a[1];
    var _b = minutesAndTod.split(' '), minutesStr = _b[0], tod = _b[1];
    var hours = parseInt(hoursStr, 10);
    var minutes = parseInt(minutesStr, 10);
    if (tod === 'p') {
        return {
            hours: hours + 12,
            minutes: minutes,
        };
    }
    return {
        hours: hours,
        minutes: minutes,
    };
}
export function readFile(f) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (r, j) {
                    var reader = new FileReader();
                    reader.onerror = function (e) { return j(e); };
                    reader.onload = function (s) { return r(reader.result); };
                    reader.readAsText(f);
                })];
        });
    });
}
export function smallScreen() {
    return Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < 550;
}
export function formatDate(date) {
    if (typeof date === 'number') {
        date = moment(date);
    }
    if (smallScreen()) {
        return date.format('M/D/YY');
    }
    return date.format('MMM DD, YYYY');
}
